import { useState } from 'react';
import { faqList } from '@/mocks/anime';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          <i className="ri-question-answer-line text-accent-400 mr-2"></i>常见问题
        </h2>
        <p className="text-sm text-foreground-400 mt-2">
          关于樱花动漫网的使用说明，快速解答您的疑问
        </p>
      </div>

      <div className="space-y-3">
        {faqList.map((faq, index) => (
          <div
            key={index}
            className="rounded-lg bg-background-100 border border-background-200/50 overflow-hidden"
          >
            <button
              className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <h4 className="text-sm md:text-base font-heading font-medium text-foreground-100 pr-4">
                {faq.question}
              </h4>
              <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center">
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-foreground-400 transition-transform duration-200`}
                ></i>
              </div>
            </button>
            {openIndex === index && (
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-400 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}